import React, { useMemo } from "react";
import style from "./treatment.module.scss";
import { VerticalTab } from "../../../secondary";
import { SecondaryDressing } from "./SecondaryDressing";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { useTreatment } from "./hooks/useTreatment";
import { InterventionDropdown } from "./InterventionDropdown";
import { TREATMENT_TAB_KEYS } from "./__fixtures__/treatment.fixtures";
import { Compression, PrimaryDressing, SkinProtectant, WoundCleanser } from "./TreatmentComponent";
import { Modalities } from "./Modalities";
import { AdditionalCare } from "./AdditionalCare";
import { DressingAppearance } from "./DressingAppearance";
import { Debridement } from "./Debridement";
import { DressingChangeFrequency } from "./DressingChangeFrequency";

const COMPONENT_MAP = {
  dressingappearance: (props) => <DressingAppearance {...props} />,
  debridement: (props) => <Debridement {...props} />,
  woundcleanser: (props) => <WoundCleanser {...props} />,
  skinprotectant: (props) => <SkinProtectant {...props} />,
  primarydressing: (props) => <PrimaryDressing {...props} />,
  secondarydressing: (props) => <SecondaryDressing {...props} />,
  compression: (props) => <Compression {...props} />,
  modalities: (props) => <Modalities {...props} />,
  additionalcare: (props) => <AdditionalCare {...props} />,
  dressingchangefrequency: (props) => <DressingChangeFrequency {...props} />,
};

export const Treatment = () => {
  const {
    assessmentDetails,
    interventionLoader,
    listOptions,
    selectedInterventionId,
    selectedInterventionName,
    dynTab,
    hideButtons,
    viewDropDown,
    defaultIndex,
    formularyId,
    dropDownRef,
    isInterventionComplete,
    hasPermission,
    handleDropDown,
    handleDropChange,
    handleClickAddIntervention,
  } = useTreatment();

  const tabList = useMemo(() => {
    if (!Array.isArray(dynTab)) return [];
    const sharedProps = { interventionId: selectedInterventionId, formularyId, assessmentDetails };
    return dynTab
      .map((data) => {
        const config = TREATMENT_TAB_KEYS.find((t) => t.key === data.key);
        if (!config || !COMPONENT_MAP[data.key]) return null;
        return {
          name: config.name,
          key: config.stateKey,
          content: COMPONENT_MAP[data.key](sharedProps),
          completed: data.isCompleted || "",
        };
      })
      .filter(Boolean);
  }, [dynTab, selectedInterventionId, formularyId, assessmentDetails]);

  const temptabList = useMemo(() => {
    const sharedProps = { interventionId: 0, formularyId, assessmentDetails };
    return TREATMENT_TAB_KEYS.map(({ key, name, stateKey }) => ({
      name,
      key: stateKey,
      content: COMPONENT_MAP[key](sharedProps),
      completed: "",
    }));
  }, [formularyId, assessmentDetails]);

  const activeTabList = selectedInterventionId === 0 ? temptabList : tabList;

  if (interventionLoader) return <Spinner className={style.spinner} />;

  return (
    <div>
      <InterventionDropdown
        listOptions={listOptions}
        selectedInterventionId={selectedInterventionId}
        selectedInterventionName={selectedInterventionName}
        viewDropDown={viewDropDown}
        dropDownRef={dropDownRef}
        hideButtons={hideButtons}
        hasPermission={hasPermission}
        isInterventionComplete={isInterventionComplete}
        onToggleDropdown={handleDropDown}
        onDropChange={handleDropChange}
        onAddIntervention={handleClickAddIntervention}
      />
      <VerticalTab tabList={activeTabList} defaultIndex={defaultIndex} interventionId={selectedInterventionId} InterventionTab={true} />
    </div>
  );
};
